<template>
  <div>
    <span v-if="vehicle.merchantOffers.data.length" class="uk-text-small uk-text-bold">Abgegebene Angebote: {{
      vehicle.merchantOffers.data.length }}</span>
    <button class="uk-button uk-button-small uk-button-primary uk-flex uk-flex-middle" @click.prevent="openOfferModal">
      <span class="uk-margin-small-right">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <path d="M3 12l3 0"></path>
          <path d="M12 3l0 3"></path>
          <path d="M7.8 7.8l-2.2 -2.2"></path>
          <path d="M16.2 7.8l2.2 -2.2"></path>
          <path d="M7.8 16.2l-2.2 2.2"></path>
          <path d="M12 12l9 3l-4 2l-2 4l-3 -9"></path>
        </svg>
      </span>
      <span>{{ buttonLabel }}</span>
    </button>
    <modal ref="offerModal" large>
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h2 class="uk-modal-title">Angebot zum Fahrzeug | {{ vehicle.number }}</h2>
      </div>
      <div class="uk-modal-body" uk-overflow-auto>
        <p class="uk-margin uk-h4">{{ vehicle.name }}</p>
        <div class="uk-grid" uk-grid>
          <div class="uk-width-expand@m">
            <ul class="uk-list">
              <li class="uk-text-bold">Verfügbare Anzahl: {{ vehicle.availableQuantity }}</li>
              <li class="uk-margin-remove">
                Leistung: {{ vehicle.powerKw }} kW ({{ vehicle.powerPs }} PS)
              </li>
              <li class="uk-margin-remove">
                Kraftstoff: {{ vehicle.fueltype }}
              </li>
            </ul>
          </div>
          <div class="uk-width-1-3@m">
            <p class="uk-margin-remove uk-text-right">
              UPE-Preis (Netto)<br />
              <span class="uk-text-bold uk-h4">{{ vehicle.priceFormatted }}</span>
            </p>
          </div>
          <div class="uk-width-1-1" v-html="vehicle.description"></div>
          <div class="uk-width-1-1">
            <table class="uk-table uk-table-hover uk-table-middle uk-table-divider">
              <thead>
                <tr style="background: #6f6f6f">
                  <th class="uk-table-expand"></th>
                  <th v-for="(offer, i) in offers" :key="i" style="color: #fff;">
                    <div class="uk-text-bold">Laufzeit {{ offer.duration }} Monate</div>
                    <div class="uk-text-bold">{{ offer.mileage | mileage }}</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Gewünschte Anzahl</td>
                  <td v-for="(offer, i) in offers" :key="i">
                    <input type="text" v-model="offer.quantity" class="uk-input">
                  </td>
                </tr>
                <tr>
                  <td>
                    Restwert in %
                  </td>
                  <td v-for="(offer, i) in offers" :key="i">
                    <input type="text" v-model="offer.percent" class="uk-input">
                  </td>
                </tr>
                <tr>
                  <td>Restwert in EURO</td>
                  <td v-for="(offer, i) in offers" :key="i">
                    {{ calculatedPrice(offer.percent) | euro }}
                  </td>
                </tr>
                <tr>
                  <td>Frachtkosten</td>
                  <td v-for="(offer, i) in offers" :key="i">
                    {{ formatedShippingCosts | euro }}
                  </td>
                </tr>
                <tr style="background: #6f6f6f;color: #fff;">
                  <td class="uk-text-bold">Rückkaufwertangebot</td>
                  <td v-for="(offer, i) in offers" :key="i">
                    <span class="uk-text-bold">{{ (calculatedPrice(offer.percent) + formatedShippingCosts) | euro
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="uk-width-1-1 uk-text-center uk-text-bold uk-text-large">
            Maximal verbleibende Anzahl: {{ vehicle.availableQuantity - totalQuantity }}
          </div>
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right">
        <div class="uk-inline">
          <button class="uk-button uk-button-primary uk-margin-small-left" @click.prevent="sendOffer"
            :disabled="isSending">
            <div v-if="isSending" data-uk-spinner="ratio: 0.7" class="uk-margin-small-right"></div>
            Angebot abgeben
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import ExchangeService from '@/services/exchange.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'

export default {
  props: ['vehicle'],

  data() {
    return {
      offers: [{
        duration: '12',
        mileage: 10000,
        quantity: 0,
        percent: 0
      }, {
        duration: '12',
        mileage: 20000,
        quantity: 0,
        percent: 0
      }, {
        duration: '24',
        mileage: 20000,
        quantity: 0,
        percent: 0
      }, {
        duration: '24',
        mileage: 40000,
        quantity: 0,
        percent: 0
      }],
      isSending: false
    }
  },
  components: {
    Modal
  },

  computed: {
    buttonLabel() {
      return this.vehicle.merchantOffers.data.length ? 'Neues Angebot abgeben' : 'Angebot abgeben'
    },
    formatedShippingCosts() {
      return this.vehicle.shippingCosts / 100
    },
    totalQuantity() {
      let sum = 0;
      this.offers.forEach(offer => {
        sum += parseFloat(offer.quantity);
      })

      return sum
    }
  },

  methods: {
    openOfferModal() {
      this.$refs.offerModal.open()
    },
    calculatedPrice(percent) {
      return (this.vehicle.price / 100) * percent / 100
    },
    sendOffer() {
      this.isSending = true
      ExchangeService.createOffer(this.vehicle.id, this.offers)
        .then(() => {
          this.isSending = false
          this.$refs.offerModal.close()
          iziToast.success({
            title: 'OK',
            message: 'Angebot gespeichert!',
            timeout: 3000,
            position: 'topCenter'
          })
          this.$emit('offerSend')
        })
        .catch(() => {
          this.isSending = false
          iziToast.error({
            title: 'Fehler!',
            message: 'Fehler beim erstellen des Angebotes',
            timeout: 5000,
            position: 'topCenter'
          })
        })
    },
    formatPrice(value) {
      let val = (value / 1).toFixed().replace('.', ',') //toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}

</script>
